// content and contentKey are Uint8Arrays
export function soundShuffle(content, contentKey) {
    const partitions = 256;
    const partitionSize = Math.ceil(content.length / partitions);
    let contentKeyArray = [... contentKey]; 

    let tempArray = undefined;

    for (let i=0; i < partitions; i++) {
        // copy partition i to keyElem
        let keyElem = (i + contentKeyArray[i % contentKeyArray.length]) % partitions;
        let position = i * partitionSize;
        let positionToCopyTo = keyElem * partitionSize;
        let subArray1 = content.subarray(position, position + partitionSize);
        tempArray = [... content.subarray(positionToCopyTo, positionToCopyTo + partitionSize)];
        if (positionToCopyTo + partitionSize > content.length ||
            position + partitionSize > content.length) {
            continue;
        }
        content.set(subArray1, positionToCopyTo);
        content.set(tempArray, position);
    }
    return content;
}

export function undoShuffle(content, contentKey) {
    const partitions = 256;
    const partitionSize = Math.ceil(content.length / partitions);
    let contentKeyArray = [... contentKey]; 

    let tempArray = undefined;

    for (let i=partitions-1; i >= 0; i--) {
        // copy partition i to keyElem
        let keyElem = (i + contentKeyArray[i % contentKeyArray.length]) % partitions;
        let position = i * partitionSize;
        let positionToCopyTo = keyElem * partitionSize;
        if (position + partitionSize > content.length || positionToCopyTo + partitionSize > content.length) {
            continue;
        }

        let subArray1 = content.subarray(position, position + partitionSize);
        tempArray = new Uint8Array(content.subarray(positionToCopyTo, positionToCopyTo + partitionSize));
        content.set(subArray1, positionToCopyTo);
        content.set(tempArray, position);
    }
    return content;
}
